import { RefObject } from 'react';

export class IFrameRefHandler {
    static instance: IFrameRefHandler | null;

    public static getInstance(ref: RefObject<HTMLIFrameElement> | any): IFrameRefHandler {
        if (!IFrameRefHandler.instance) {
            IFrameRefHandler.instance = new IFrameRefHandler(ref);
        }
        return IFrameRefHandler.instance;
    }

    static createFromReactRef(ref: RefObject<HTMLIFrameElement>) {
        return new IFrameRefHandler(ref);
    }

    constructor(private ref: RefObject<HTMLIFrameElement>) {
        this.ref = ref;
    }

    public postMessage(cmd: any) {
        const SDKURL = process.env.REACT_APP_THREED_SDK_STAGING_URL as string;
        this.ref?.current?.contentWindow?.postMessage(JSON.stringify(cmd), SDKURL);
    }
}
